<template>
    <div>
        <v-breadcrumbs :items="crumbs" divider="/" style="background-color: #f0f0f0">
        </v-breadcrumbs>
        <v-card class="mx-auto" outlined tile color="#F8F8FF">
        <v-card-title>Boom Gate</v-card-title>
        <v-container fluid>
            <v-row>
                <!--
                <v-col cols="12" md="6"><v-btn v-if="validateAccess('system_add')" :loading="btn_loading" :disabled="btn_loading" tile type="submit" small color="primary" @click="viewMore(1, 'create')"><v-icon left x-small dark>fa fa-cogs</v-icon>Create System
                    <template v-slot:loader>
                        <span>Loading...</span>
                    </template>
                    </v-btn>
                </v-col>
                -->
                <v-btn-toggle class="col-12 offset-md-6 col-md-6" style="background: none">
                    <v-btn small disabled>
                        <v-icon small>fa fa-search</v-icon>
                    </v-btn>
                    <v-text-field placeholder="Search" class="search-textfield" hide-details outlined dense v-model="search"></v-text-field>
                </v-btn-toggle>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-autocomplete
                            dense
                            outlined
                            placeholder="All Operators"
                            label="Operator"
                            v-model="operator.selected"
                            @change="execFilter('operator')"
                            :items="operator.items"
                            item-text="name"
                            item-value="OperatorID"
                            :rules="operator.rule"
                            :loading="operator.loader"
                            :disabled="operator.disable"
                            hide-details
                            >
                            </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="All Car Parks"
                    label="Car Park"
                    v-model="carpark.selected"
                    @change="execFilter('carpark')"
                    :items="carpark.items"
                    item-text="name"
                    item-value="CarParkID"
                    :rules="carpark.rule"
                    :loading="carpark.loader"
                    :disabled="carpark.disable"
                    hide-details
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="8">
                    <v-pagination
                    v-model="page"
                    :length.sync="pages"
                    :total-visible="6"
                    class="mt-4"
                    style="float: left !important"
                    ></v-pagination><br/><p class="text-caption" style="margin-left: 10px">Page {{page}} of {{pages}}</p>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col><span class="text-body-2">View {{page > 1 ? (page - 1) * 100 + 1 : 1}} - {{getCount}} of {{totalrecords}}</span></v-col>
                <v-col cols="12" md="12" id="table-parent">
                    <div id="wrapper1">
                        <div id="div1">
                        </div>
                    </div>
                    <v-data-table
                        calculate-widths
                        :headers="headers"
                        :items="items"
                        hide-default-footer
                        :loading="tableloading"
                        loading-text= "Loading Data... Please wait"
                        :items-per-page="100"
                        id="main-table"
                        dense
                        sort-by="GateID"
                        sort-desc
                    >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{page > 1 ? (page - 1) * 100 + props.index + 1 : props.index + 1}}</td>
                            <td>{{props.item.GateControllerID}}</td>
                            <td>{{props.item.RefControllerID}}</td>
                            <td>{{props.item.GateID}}</td>
                            <td>{{props.item.RefGateID}}</td>
                            <td>
                                <v-tooltip top v-if="validateAccess('gate_upgate') && props.item.GateCareToken != null">
                                    <template v-slot:activator="{on}">
                                        <a v-on="on" id="custom-hover" @click.prevent="viewMore(props.item, 'open')">
                                            <v-icon small color="green">fas fa-door-open</v-icon>
                                        </a>
                                    </template>
                                    <span>Open Gate</span>
                                </v-tooltip>
                                <span v-else>N/A</span>
                            </td>
                            <td>{{props.item.GateType}}</td>
                            <td>{{props.item.CarParkID}}</td>
                            <td>{{props.item.CarParkUserInputCode}}</td>
                            <td>{{props.item.CarParkName}}</td>
                            <td>{{props.item.PoleDesc}}</td>
                            <td>{{props.item.Remark}}</td>
                            <td>
                                <v-tooltip top v-if="validateAccess('gate_updateisentry')">
                                <template v-slot:activator="{ on }">
                                <v-chip
                                v-on="on"
                                @click="viewMore(props.item, 'updateentry')"
                                label
                                x-small
                                class="ma-2"
                                :color="isEntry(props.item.IsEntryGate, 'color')"
                                text-color="white">
                                    {{isEntry(props.item.IsEntryGate, 'text')}}
                                </v-chip>
                                </template>
                                <span>Update Is Entry</span>
                                </v-tooltip>
                                <v-chip
                                v-else
                                label
                                x-small
                                class="ma-2"
                                :color="isEntry(props.item.IsEntryGate, 'color')"
                                text-color="white">
                                    {{isEntry(props.item.IsEntryGate, 'text')}}
                                </v-chip>
                            </td>
                            <td v-if="validateAccess('gate_viewdetails')">
                                <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <a style="text-decoration: underline" id="custom-hover" v-on="on" @click.prevent="viewMore(props.item, 'viewconnection')">Connection</a>
                                </template>
                                <span>View Connection</span>
                                </v-tooltip>
                            </td>
                            <td>
                                <v-chip
                                x-small
                                class="ma-2"
                                :color="statusCheck(props.item.Enabled, 'color')"
                                text-color="white">
                                    {{statusCheck(props.item.Enabled, 'text')}}
                                </v-chip>
                            </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        </v-card>
        <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
        </v-snackbar>
        <edit :dialog="ma.modal_update" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :readonly="ma.readonly" :allInfo="ma.allInfo" :carpark="carpark.itemsFull" @confirm="onConfirm" @closed="onClosed"></edit>
        <editentry :dialog="ma.modal_updateentry" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :readonly="ma.readonly" :allInfo="ma.allInfo" :carpark="carpark.itemsFull" @confirm="onConfirm" @closed="onClosed"></editentry>
        <viewconnection :dialog="ma.modal_viewconnection" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :readonly="ma.readonly" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></viewconnection>
        <viewinfo :dialog="ma.modal_viewinfo" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :readonly="ma.readonly" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></viewinfo>
        <alert :dialog="ma.modal_status" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alert>
        <!--
        <create :dialog="ma.modal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></create>
        <edit :dialog="ma.modal_update" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :readonly="ma.readonly" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></edit>
        
        <alertbox2 :dialog="ex.modal" @closed="onClosed" :content="ex.content"></alertbox2>
        -->
    </div>
</template>
<script>
import timer from '../../assets/js/sleeper';
import edit from '.././modals/UpdateGate';
import editentry from '.././modals/UpdateGateEntry';
import viewconnection from '.././modals/ViewGateConnection';
import viewinfo from '.././modals/ViewGateInfo';
import alert from '.././modals/Alert';
import {ERR} from '../../assets/js/errhandle.js';
import alertbox2 from '../modals/Notification';
import * as moment from "moment";
import * as tz from "moment-timezone";
import {rule} from '../../assets/js/checkPerm';

export default {
    name: 'Boom Gate',
    title: 'Boom Gate',
    
    data()  {
        return {
            crumbs: [
                {
                text: 'Home',
                disabled: true,
                href: '#',
                },

                {
                text: 'Boom Gate',
                disabled: true,
                href: '#',
                },

                {
                text: 'Boom Gate',
                disabled: true,
                href: '#',
                },
            ],
            items: [],
            search: '',
            /*6. Boom Gate -> table -> #, SPR ID, Gate ID, Gate Ref., Type, Operator, CP ID, Car Park, Pole No., Remark, Last Seen, Status*/
            headers: [
                { text: '#', value: 'row', width: '3%' },
                { text: 'Controller ID', value: 'GateControllerID', width: '3%' },
                { text: 'Controller Ref.', value: 'RefControllerID', width: '3%' },
                { text: 'Gate ID', value: 'GateID', width: '3%' },
                { text: 'Gate Ref.', value: 'RefGateID', width: '3%' },
                { text: 'Action', value: 'Action', width: '3%' },
                { text: 'Type', value: 'GateType', width: '3%' },
                { text: 'CP ID', value: 'CarParkID', width: '3%' },
                { text: 'CP Code', value: 'CarParkUserInputCode', width: '3%' },
                { text: 'Car Park', value: 'CarParkName', width: '5%' },
                { text: 'Pole No.', value: 'PoleDesc', width: '5%' },
                { text: 'Remark', value: 'Remark', width: '5%' },
                { text: 'Is Entry', value: 'IsEntryGateText', width: '5%' },
                { text: 'Last Seen', value: 'lastSeenDate', width: '5%' },
                { text: 'Status', value: 'Enabled', width: '5%' },
            ],
            tableloading: false,
            btn_loading: false,
            pages: 0,
            page: 1,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                confirmCreate: false,

                modal_status: false,
                modal_update: false,
                modal_updateentry: false,
                modal_reset: false,
                readonly: true,
                allInfo: [],

                modal_viewconnection: false,
                modal_viewinfo: false,
            },
            pdfurl: '',

            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: ''
                }
            },

            operator: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },
            carpark: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },
            controller: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },
            displaystatus: {
                counter: 0,
                selected: null,
                rerender: 0,
                label: 'All Mobile Display Status'
            },
            toggle_exclusive_search: 0,
            totalrecords: '',
            timer: '',
            autoRefresh: '',
        }
    },

    components: {edit, alert, alertbox2, viewconnection, viewinfo, editentry},

    async created(){
        await this.getHeaders();
        await this.getOperatorFull();
        await this.getCarParkFull();
        this.listItems(1);
        this.horizontalScroll();
    },

    watch: {
        page: {
        handler: function(value) {
            this.items = [];
            this.listItems();
        }
        },

        'search': {
        handler: function(value) {
            this.searchTimeOut();
        }
        },

        'toggle_exclusive_search': {
        handler: function(value) {
            if (this.search != '')
            this.searchTimeOut();
        }
        },

        /*
        'autoRefresh': {
        handler: function(value) {
            //console.log(value +'--'+ this.timer)
            if (value != 0){
                let self = this;
                let truth = false;
                document.addEventListener('visibilitychange', function() {
                    truth = true;
                    if(document.hidden) {
                        clearInterval(self.timer);
                        truth = false;
                    }
                    else {
                        if (truth)
                        self.timer = setInterval(self.listItems, 30000);
                    }
                });

                if (!truth){
                    self.timer = setInterval(self.listItems, 30000);
                }
            }

            else {
                clearInterval(this.timer);
            }
        },
        },
        */
    },

    /*
    async beforeRouteLeave (to, from , next) {
        clearInterval(this.timer);
        next();
    },
    */

    computed: {
        getCount(){
            if (this.items.length > 0)
                return this.items[this.items.length - 1].row;

                else{
                    return '';
                }
            },
    },

    methods: {
        async listItems(pg){
            this.autoRefresh = 1;
            this.items = [];

            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("getGate", {page: pg > 0 ? this.page = pg : this.page, operatorid: this.operator.selected, carparkid: this.carpark.selected, search: this.search });
                let response2 = await this.$store.dispatch("getGateControllerFORGATE_TEMP", {});
                let response3 = await this.$store.dispatch("getAllCarpark2", {search: ''});
                if (response.data.code == 'AP000'){
                let dt = response.data.record;
                let dt2 = response2.data.record;
                let dt3 = response3.data.record;
                let recordCount = response.data.recordcount;
                this.totalrecords = recordCount;
                this.controller.itemsFull = dt2;

                for(var i=0; i<dt.length; i++){
                    dt[i].forentryGateID = dt[i].GateID;
                    dt[i].forentryRefGateID = dt[i].RefGateID;
                    dt[i].forentryGateToken = dt[i].GateToken;
                    dt[i].forentryGateControllerID = dt[i].GateControllerID;
                    dt[i].forentryCarParkID = dt[i].CarParkID;
                    dt[i].forentryGateType = dt[i].GateType;
                    dt[i].forentryPoleDesc = dt[i].PoleDesc;
                    dt[i].forentryRemark = dt[i].Remark;
                    dt[i].forentryIsEntryGate = dt[i].IsEntryGate;
                    dt[i].forentryEnabled = dt[i].Enabled;

                    dt[i].row = this.page > 1 ? (this.page - 1) * 100 + i + 1 : i + 1;
                    dt[i].CreateDate = moment(dt[i].CreateDate).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].UpdateDate = moment(dt[i].UpdateDate).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].lastConnectDate = dt[i].lastConnectDate == null ? "N/A" : moment.unix(dt[i].lastConnectDate).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].lastDisconnectDate = dt[i].lastDisconnectDate == null ? "N/A" : moment.unix(dt[i].lastDisconnectDate).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].lastSeenDate2 = dt[i].lastSeenDate == null ? "N/A" : moment.unix(dt[i].lastSeenDate).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].lastPinDate = dt[i].lastPinDate == null ? "N/A" : moment.unix(dt[i].lastPinDate).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].lastOpenDate = dt[i].lastOpenDate == null ? "N/A" : moment.unix(dt[i].lastOpenDate).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].lastPresentDate = dt[i].lastPresentDate == null ? "N/A" : moment.unix(dt[i].lastPresentDate).format('DD-MM-YYYY hh:mm:ss A');
                    dt[i].lastAbsentDate = dt[i].lastAbsentDate == null ? "N/A" : moment.unix(dt[i].lastAbsentDate).format('DD-MM-YYYY hh:mm:ss A');

                    let operator = dt2.find(item => item.GateControllerID == dt[i].GateControllerID);
                    dt[i].OperatorID = operator == undefined ? '' : operator.OperatorID;
                    dt[i].CarParkID = operator == undefined ? '' : operator.CarParkID;
                    dt[i].CarParkName = operator == undefined ? '' : operator.CarParkName;

                    let carpark = dt3.find(item => item.CarParkID == dt[i].CarParkID);
                    dt[i].CarParkUserInputCode = carpark == undefined ? '' : carpark.CarParkUserInputCode;
                    dt[i].CarParkUserInputCode = dt[i].CarParkUserInputCode == "" || dt[i].CarParkUserInputCode == null ? "N/A" : dt[i].CarParkUserInputCode;
                    dt[i].IsEntryGateText = dt[i].IsEntryGate == 1 ? 'Entry' : "Exit";
                    dt[i].GateType = dt[i].GateType == "" || dt[i].GateType == null ? 'N/A' : dt[i].GateType;
                    dt[i].PoleDesc = dt[i].PoleDesc == "" || dt[i].PoleDesc == null ? 'N/A' : dt[i].PoleDesc;
                    dt[i].Remark = dt[i].Remark == "" || dt[i].Remark == null ? 'N/A' : dt[i].Remark;
                }
                
                this.items = dt;
                this.pages = Math.ceil(recordCount / 100);
                this.tableloading = false;
                }
            }

            catch(err){
                console.log(err);
            }
        },

        async getOperatorFull(){
            let list = [];
            this.operator.items = [];
            this.operator.selected = "";

            try{
                this.operator.loader = true;
                this.operator.disable = true;

                let self = this;
                let response = await this.$store.dispatch("listOperator", {search: ''});
                let dt = response.data.record;
                if (response.data.code == 'AP000'){
                    this.operator.items.push({name: "All Operators", OperatorID: ""});
                    this.operator.itemsFull.push({name: "All Operators", OperatorID: ""});

                for(var i=0; i<dt.length; i++){
                    if (dt[i].SystemID === 2){
                        dt[i].name = `${dt[i].OperatorID} - ${dt[i].OperatorName}`;
                        this.operator.items.push({name: dt[i].name, OperatorID: dt[i].OperatorID});
                        this.operator.itemsFull.push(dt[i]);
                    }
                }

                this.operator.selected = this.operator.items[0].OperatorID;
                }

                //this.operator.itemsFull = dt;

                this.operator.loader = false;
                this.operator.disable = false;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        async getCarParkFull(){
            let list = [];
            this.carpark.items = [];
            this.carpark.selected = "";

            try{
                this.carpark.loader = true;
                this.carpark.disable = true;

                let self = this;

                if (this.operator.selected){
                    let carpark = this.carpark.itemsFull.filter(item => {
                    return item.OperatorID == self.operator.selected;
                    });

                    this.carpark.items.push({name: "All Car Parks", CarParkID: ""});

                    for(var i=0; i<carpark.length; i++){
                        carpark[i].name = `${carpark[i].CarParkID} - ${carpark[i].CarParkName}`;
                        this.carpark.items.push({name: carpark[i].name, CarParkID: carpark[i].CarParkID});
                    }

                    //this.operator.selected = this.operator.items[1].OperatorID;
                }

                else{
                    let response = await this.$store.dispatch("getAllCarpark2", {});
                    let dt = response.data.record;
                    if (response.data.code == 'AP000'){
                        this.carpark.items.push({name: "All Car Parks", CarParkID: ""});
                        this.carpark.itemsFull.push({name: "All Car Parks", CarParkID: ""});

                    for(var i=0; i<dt.length; i++){
                        if (dt[i].SystemID === 2){
                            dt[i].name = `${dt[i].CarParkID} - ${dt[i].CarParkName}`;
                            this.carpark.items.push({name: dt[i].name, CarParkID: dt[i].CarParkID});
                            this.carpark.itemsFull.push(dt[i]);
                        }
                    }

                    this.carpark.selected = this.carpark.items[0].CarParkID;
                    }
                }

                //this.operator.itemsFull = dt;

                this.carpark.loader = false;
                this.carpark.disable = false;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        async updateGate(v){
            try{
                this.tableloading = true;
                let req = {
                    "GateID": v.GateID.item,
                    "RefGateID": Number(v.RefGateID.item),
                    "GateToken": v.GateToken.item,
                    "GateControllerID": v.GateControllerID.selected,
                    "CarParkID": v.carpark.selected,
                    "GateType": v.GateType.selected,
                    "PoleDesc": v.PoleDesc.item,
                    "Remark": v.Remark.item,
                    "IsEntryGate": this.ma.modalInfo.forentryIsEntryGate,
                    "Enabled": v.Enabled.item == true ? 1 : false
                };
                let response = await this.$store.dispatch("updateGate", req)
                if (response.data.code === 'AP000'){
                        await this.listItems(1);

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Gate has been updated!`;
                }

                else if (response.data.code === 'RD002'){
                        this.swal.notification = true;
                        this.swal.scolor = 'red';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Unable to update.`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
            }

            catch(err){
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        //same api as update gate
        async updateGateIsEntry(v){
            try{
                this.tableloading = true;
                let req = {
                    "GateID": Number(this.ma.modalInfo.forentryGateID),
                    "RefGateID": Number(this.ma.modalInfo.forentryRefGateID),
                    "GateToken": this.ma.modalInfo.forentryGateToken,
                    "GateControllerID": this.ma.modalInfo.forentryGateControllerID,
                    "CarParkID": this.ma.modalInfo.forentryCarParkID,
                    "GateType": this.ma.modalInfo.forentryGateType,
                    "PoleDesc": this.ma.modalInfo.forentryPoleDesc,
                    "Remark": this.ma.modalInfo.forentryRemark,
                    "IsEntryGate": v.IsEntryGate.selected,
                    "Enabled": this.ma.modalInfo.forentryEnabled
                };
                let response = await this.$store.dispatch("updateGate", req)
                if (response.data.code === 'AP000'){
                        await this.listItems(1);

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Gate Entry/Exit has been updated!`;
                }

                else if (response.data.code === 'RD002'){
                        this.swal.notification = true;
                        this.swal.scolor = 'red';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Unable to update.`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
            }

            catch(err){
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        async createGate(v){
            this.btn_loading = true;
            this.tableloading = true;
            try{
                this.swal.scolor = 'green';
                let req = {
                    "GateControllerID": v.controller.selected,
                    //"GateType": v.GateType.item,
                    "RefGateID": Number(v.RefGateID.item),
                    //"GateToken": v.GateToken.item,
                    //"IsEntryGate": v.IsEntryGate.selected,
                    //"PoleDesc": v.PoleDesc.item,
                    //"Remark": v.Remark.item,
                    //"Enabled": v.Enabled.item == true ? 1 : false
                };
                let response = await this.$store.dispatch("createGate", req);
                await timer.sleep(800);
                if (response.data.code === 'AP000'){
                    await this.listItems(1);
                    this.swal.notification = true;
                    this.swal.scolor = 'green';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: Gate Created!`;
                }
                else if (response.data.code === 'RD002'){
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: Invalid Setup`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
                this.btn_loading = false;
            }

            catch(err){
                this.swal.notification = true;
                this.swal.scolor = 'red';
                this.swal.message = 'Something went wrong. Please try again later';
                this.tableloading = false;
                this.btn_loading = false;
            }
        },

        async resetGate(v){
            try{
                this.tableloading = true;
                let req = {
                    "GateID": v.GateID,
                };
                let response = await this.$store.dispatch("resetGate", req)
                if (response.data.code === 'AP000'){
                        await this.listItems(1);

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Gate UUID has been reset!`;
                }

                else if (response.data.code === 'RD002'){
                        this.swal.notification = true;
                        this.swal.scolor = 'red';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Unable to reset.`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
            }

            catch(err){
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        getHeaders(){
            if (this.validateAccess('gate_viewdetails'))
                this.headers;

            else
                this.headers.splice(12, 1);
        },

        validateAccess(val){
            let access = JSON.parse(JSON.stringify(this.$store.getters.getAccess))
            return rule.checkaccess(val, access);
        },

        viewMore(row, flag){
            this.autoRefresh = 0;
            if (flag == 'delete'){
                this.ma.modal_status = true;
                this.ma.modalInfo = row;
            }

            if (flag == 'create'){
                this.ma.modal = true;
                this.ma.allInfo = this.items;
            }

            if (flag == 'update'){
                this.ma.modal_update = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = false;
            }

            if (flag == 'updateentry'){
                this.ma.modal_updateentry = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = false;
            }

            if (flag == 'view'){
                this.ma.modal_update = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = true;
            }

            if (flag == 'viewconnection'){
                this.ma.modal_viewconnection = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = true;
            }

            if (flag == 'viewinfo'){
                this.ma.modal_viewinfo = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = true;
            }

            if(flag == 'open'){
                this.ma.modal_status = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = true;
            }

            this.ma.customText = {text1: "Gate ID", text2: "Name"};
            this.ma.modal_action_type = flag;
        },

        viewReset(row){
            this.autoRefresh = 0;
            this.ma.modal_reset = true;
            this.ma.modalInfo = row;
            this.ma.allInfo = this.items;
            this.ma.readonly = true;
            
            this.ma.customText = {text1: "Gate ID", text2: "Name"};
        },

        onClosed(value){
            console.log(value)
            if (value == false){
                this.autoRefresh = 0;
                this.ma.modal = value;
                this.ma.modal_status = value;
                this.ma.modal_update = value;
                this.ma.modal_updateentry = value;
                this.ma.modal_reset = value;
                this.ex.modal = value;
                this.ma.modal_viewconnection = value;
                this.ma.modal_viewinfo = value;

                /*
                setTimeout(() => {
                this.listItems();
                }, 100);
                */
            }
        },

        onConfirm(value){
            console.log(value)
            if (value.flag === 'create'){
                this.ma.confirmCreate = true;
                this.ma.modal = false;
                this.createGate(value);
            }

            if (value.flag === 'update'){
                this.ma.modal_update = false;
                this.updateGate(value);
            }

            if (value.flag === 'updateentry'){
                this.ma.modal_updateentry = false;
                this.updateGateIsEntry(value);
            }

            if (value === true){
                if (this.ma.modal_action_type == 'delete')
                {
                    this.ma.modal_status = false;
                    this.systemRemove();
                }
                if(this.ma.modal_action_type == 'open'){
                    this.ma.modal_status = false;
                    this.gateOpen();
                }
            }

            if (value.flag === 'reset'){
                this.ma.modal_reset = false;
                console.log('reset', value);
                this.resetGate(value);
            }
        },

        async execFilter(type){
            if (type == 'system'){
                await this.getOperatorFull();
                await this.getCarParkFull();
                await this.searchTimeOut();
            }

            if (type == 'operator'){
                await this.getCarParkFull();
                await this.searchTimeOut();
            }

            if (type == 'carpark'){
                await this.searchTimeOut();
            }

            if (type == 'displaystatus'){
                this.displaystatus.counter++;
                if (this.displaystatus.counter % 3 == 0){
                    this.displaystatus.rerender++;
                    this.displaystatus.selected = null;
                    this.displaystatus.label = "All Mobile Display Status";
                }

                if (this.displaystatus.selected === true){
                    this.displaystatus.label = "Mobile Display Status Enable";
                }

                if (this.displaystatus.selected === false){
                    this.displaystatus.label = "Mobile Display Status Disable";
                }
                await this.searchTimeOut();
            }
        },

        searchTimeOut() {

          clearTimeout(this.timeout);

          // Make a new timeout set to go off in 800ms
          this.timeout = setTimeout(() => {
          this.listItems(1);
          }, 800);
        },

        statusCheck(val, typ){
            if (typ == 'text'){
                    if (val === 1){ return 'Enable'}
                    else if (val === 0){return 'Disable'}
                    else {return 'null'}
            }

            if (typ == 'color'){
                    if (val === 1){ return 'green'}
                    else if (val === 0){return 'red'}
                    else {return 'grey'}
            }
        },

        isEntry(val, typ){
            if (typ == 'text'){
                    if (val === 1){ return 'Entry'}
                    else if (val === 0){return 'Exit'}
                    else {return 'N/A'}
            }

            if (typ == 'color'){
                    if (val === 1){ return '#4181AE'}
                    else if (val === 0){return '#333333'}
                    else {return 'grey'}
            }
        },

        horizontalScroll(){
            var wrapper1 = document.getElementById('wrapper1');
            var wrapper2 = document.querySelector('.v-data-table__wrapper');
            document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
            document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;

            if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";

            window.addEventListener('resize', function() {
                document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
                document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;

                if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";
            });

            const myObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                document.getElementById('wrapper1').style.width = `${String(document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth)}px`;
                document.getElementById('div1').style.width = `${String(document.getElementsByTagName("table")[0].offsetWidth)}px`;
                console.log('table', document.getElementsByClassName("v-data-table__wrapper")[0].offsetWidth);
                console.log('parent', document.getElementById("table-parent").offsetWidth);

                if (document.getElementsByClassName("v-data-table-header")[0].offsetWidth < document.getElementById("table-parent").offsetWidth)
                    document.getElementById('wrapper1').style.display = "none";

                else
                    document.getElementById('wrapper1').style.display = "block";
            });
            });

            const someEl = document.getElementsByTagName("table")[0];
            myObserver.observe(someEl);


            wrapper1.onscroll = function() {
            wrapper2.scrollLeft = wrapper1.scrollLeft;
            };
            wrapper2.onscroll = function() {
            wrapper1.scrollLeft = wrapper2.scrollLeft;
            };
        },

        showConnect(item, typ){
            if (typ == 'text'){
                    if ((Math.round((new Date()).getTime() / 1000) - item) / 60 <= 5)
                        return 'Connected';

                    else
                        return 'Disconnected';
            }

            if (typ == 'color'){
                    if ((Math.round((new Date()).getTime() / 1000) - item) / 60 <= 5)
                        return 'green';

                    else
                        return 'red';
            }
        },

        beforeDestroy () {
            clearInterval(this.timer);
        },
        async gateOpen(){
            await this.$store.dispatch('openGate', {
                gatetoken: this.ma.modalInfo.GateCareToken,
                carparkID: this.ma.modalInfo.CarParkID
            });
        }
    }
}
</script>